import { request } from "services/api/util";

class BroadcastMessagesService {
  async getListBroadcastMessages(param) {
    const config = {
      method: "get",
      url: `admin/broadcastMessages`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailBroadcastMessage(id) {
    const config = {
      method: "get",
      url: `admin/broadcastMessages/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createBroadcastMessage(body) {
    let config;
    config = {
      method: "post",
      url: `admin/broadcastMessages`,
      data: body,
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return request(config);
  }

  async getBroadcastMessageResult(param) {
    const config = {
      method: "get",
      url: `admin/broadcastMessages/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async cancelBroadcastMessage(id) {
    const config = {
      method: "post",
      url: `admin/broadcastMessages/cancel/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getBroadcastMessageCancelResult(param) {
    const config = {
      method: "get",
      url: `admin/broadcastMessages/cancel/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new BroadcastMessagesService();
